export const collaboratorTypes = {
    AMO: 0,
    INSTALLATEUR: 1 ,
    INGENIEUR: 2 
}